// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
    <sub-header header="\$ctrl.actionName"></sub-header>

    <h2 class="section-header">{{ \$ctrl.actionName }}</h2>
    <form name="\$ctrl.transactionForm" novalidate>
      <table class="misc-transaction__table table table--generate-row-ids">
        <tbody>
          <tr ng-if="['CHECK_IN', 'BATCH_CHECK_IN'].includes(\$ctrl.actionCode)">
            <td></td>
            <td>MICR number</td>
            <td>
              <micr-number ng-model="\$ctrl.checkModel.micrNumber"></micr-number>
            </td>
          </tr>

          <tr ng-if="['CHECK_IN', 'BATCH_CHECK_IN'].includes(\$ctrl.actionCode)">
            <td></td>
            <td>Valid from</td>
            <td>
              <date
                ng-required="['CHECK_IN', 'BATCH_CHECK_IN'].includes(\$ctrl.actionCode)"
                ng-model="\$ctrl.checkModel.validFrom">
              </date>
            </td>
          </tr>

          <tr ng-if="['CHECK_IN', 'BATCH_CHECK_IN'].includes(\$ctrl.actionCode)">
            <td></td>
            <td>Issuing bank</td>
            <td>
              <selectize options="\$ctrl.banks"
                         config="\$ctrl.selectConfig"
                         ng-required="['CHECK_IN', 'BATCH_CHECK_IN'].includes(\$ctrl.actionCode)"
                         ng-model="\$ctrl.checkModel.bankId">
              </selectize>
            </td>
          </tr>

          <tr>
            <td></td>
            <td>Amount:</td>
            <td>
              <cash ng-model="\$ctrl.checkModel.amount"
                    ng-model-options="{ debounce: 250 }"
                    required></cash>
            </td>
          </tr>

          <tr>
            <td></td>
            <td>Remarks:</td>
            <td>
              <input
                type="text"
                maxlength="512"
                ng-model="\$ctrl.checkModel.remarks"
                required/>
            </td>
          </tr>

          <tr>
            <td></td>
            <td>Category:</td>
            <td>
              <gl-category-select
              required
              action-type="(\$ctrl.actionCode === 'BATCH_CHECK_IN' ? 'CHECK_IN' : \$ctrl.actionCode)"
              is-selectize="true"
              ng-model="\$ctrl.category"
              single-accounts-only = "false"
              ng-change="\$ctrl.onCategoryChange()"
            >
            </gl-category-select>
            </td>
          </tr>
        </tbody>
      </table>

      <ledger-units
        units="\$ctrl.checkModel.units"
        entry-type="\$ctrl.entryType"
        amount="\$ctrl.checkModel.amount"
        fixed-account-label="\$ctrl.fixedAccountLabel"
        blocked-units="\$ctrl.blockedUnits"
        always-blocked="true"
        hide-contingent="true">
      </ledger-units>

      <div class="buttons"
           ng-if="\$ctrl.actionCode === 'BATCH_CHECK_IN'">
        <button type="button"
                class="btn btn-success"
                ng-click="\$ctrl.addCheck()"
                ng-disabled="\$ctrl.transactionForm.\$invalid">
          Add
        </button>
      </div>

      <div class="checks-summary"
           ng-if="\$ctrl.actionCode === 'BATCH_CHECK_IN'">
        <table class="checks-summary__table table">
          <thead>
          <tr>
            <th>#</th>
            <th>MICR Number</th>
            <th>Valid from</th>
            <th>Issuing bank</th>
            <th>Amount</th>
            <th>GL account</th>
            <th>Debit</th>
            <th>Credit</th>
            <th></th>
          </tr>
          </thead>
          <tbody ng-if="\$ctrl.userChecks.length > 0">
            <tr ng-repeat="check in \$ctrl.userChecks track by \$index">
              <td>{{ \$index + 1 }}.</td>
              <td>{{ check.micrNumber | micr }}</td>
              <td>{{ check.validFrom | nxDate }}</td>
              <td>{{ check.bankName }}</td>
              <td>
                <cash ng-disabled="true" ng-model="check.amount"></cash>
              </td>
              <td>
                <div ng-repeat="unit in check.units" ng-if="unit.accountCode">
                  {{ unit.accountCode }}
                  <help title="{{ \$ctrl.glAccountLabels[unit.accountCode] }}"></help>
                </div>
              </td>
              <td>
                <cash ng-disabled="true" ng-model="check.totalDebitAmount"></cash>
              </td>
              <td>
                <cash ng-disabled="true" ng-model="check.totalCreditAmount"></cash>
              </td>
              <td>
                <button type="button" class="btn btn-danger" ng-click="\$ctrl.removeCheck(\$index)">
                  Remove
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="3"></td>
              <td class="checks-summary__total-amount-label">TOTAL</td>
              <td>
                <cash ng-disabled="true" ng-model="\$ctrl.totalAmount"></cash>
              </td>
              <td colspan="4"></td>
            </tr>
          </tbody>
        </table>
        <div  ng-if="\$ctrl.userChecks.length < 1" class="empty-message">
          <span>No checks have been added yet.</span>
        </div>
      </div>

      <div class="buttons">
        <button
          class="misc-transaction__cancel btn btn-warning"
          ng-click="\$ctrl.cancelChanges()">
          Cancel
        </button>
        <button
          type="submit"
          class="misc-transaction__save btn btn-primary"
          ng-disabled="\$ctrl.isSaveButtonDisabled()"
          ng-click="\$ctrl.save()">
          Transfer now
        </button>
      </div>
    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/funds-movement/funds-movement.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;